/**
 * The app's ONE vertical scroller (GDN-3220): RootView's `#root-main`.
 * The shell clamps to 100dvh, and `#root-main` declares `overflowX:
 * hidden` — per CSS, a non-visible value on one axis computes the other's
 * `visible` to `auto` — so page content scrolls INSIDE that box, never
 * the window. `window.scrollY` is always ~0 in this app. (Found
 * empirically with a scroll-height probe; two static guesses — window,
 * then #root-container — were both wrong. The e2e keeps the probe.)
 *
 * Every feature that reads or writes page scroll must go through here:
 * RootView consumes the id, so the two can't drift apart, and call sites
 * fall back to the window for contexts without the shell (tests,
 * Storybook, a future layout where the window really does scroll).
 */

export const APP_SCROLL_CONTAINER_ID = 'root-main';

export function getAppScroller(): HTMLElement | null {
  return document.getElementById(APP_SCROLL_CONTAINER_ID);
}

/** Current vertical offset of the page, wherever it actually scrolls. */
export function getAppScrollTop(): number {
  return getAppScroller()?.scrollTop ?? window.scrollY;
}

/** Scroll the page to a vertical offset, wherever it actually scrolls. */
export function scrollAppTo(top: number): void {
  const scroller = getAppScroller();
  if (scroller) {
    scroller.scrollTo({ top });
    return;
  }
  window.scrollTo({ top });
}
